import jwtDecode from 'jwt-decode'; 
import { get, post } from '../services/api';

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const handleLogin = (username) => {
  localStorage.setItem("loggedIn", "true");
  localStorage.setItem("username", username);
  sessionStorage.removeItem('manual_logout');
};

export const logout = () => {
  sessionStorage.setItem('manual_logout', 'true');
  localStorage.clear();
};

export const verifyAdmin = (token = null) => {
  const adminToken = token || localStorage.getItem("adminToken")

  if(adminToken == null)
    return false
  const user = jwtDecode(adminToken);
    
  return user.isAdmin;
}

export const isUserAuthenticated = (isAdmin) => {
  const loggedIn = localStorage.getItem("loggedIn");
  if(isAdmin){
    if(verifyAdmin() == false) return false;
  }
  return loggedIn === "true";
};

export const getLoggedInUsername = () => {
  return localStorage.getItem("username");
};

export const isTokenExpired = (token) => {

  const jwtDecoded = jwtDecode(token);

  const expirationTimestamp = jwtDecoded.exp;

  const expirationDate = new Date(expirationTimestamp * 1000);

  const currentDate = new Date();

  return expirationDate <= currentDate;
  
};

export const tryAuthenticateViaCookie = async (respectManualLogout = true) => {
  try {
    const isLocalhost = window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';

    if (isLocalhost) {
      if (isUserAuthenticated(false)) {
        return true;
      }
      return false;
    }

    if (respectManualLogout) {
      const manualLogout = sessionStorage.getItem('manual_logout');
      if (manualLogout === 'true') {
        return false;
      }
    }

    const justLoggedIn = sessionStorage.getItem('just_logged_in');
    if (justLoggedIn === 'true') {
      sessionStorage.removeItem('just_logged_in');
      return true;
    }

    const jwtCookie = getCookie('mmauthjwt');
    
    if (!jwtCookie) {
      return false;
    }
    
    const isAuth = isUserAuthenticated(false);
    
    if (isAuth) {
      const lastUsedJwt = localStorage.getItem('last_jwt_cookie');
      
      if (lastUsedJwt === jwtCookie) {
        return true;
      }
    }

    const response = await post('/login/autenticacaojwt', { jwt: jwtCookie });
    
    if (!response || response.error || response.Mensagem) {
      if (isAuth) {
        return true;
      }
      return false;
    }
    
    if (response.loginValido && response.loginAutorizado) {
      const jwtDecoded = jwtDecode(response.jwt);
      const idDepartamentoUsuario = jwtDecoded.legacy_roles?.id_departamento;
      const idVendedorUsuario = jwtDecoded.legacy_roles?.vendedor;
      const idUsuario = jwtDecoded.legacy_roles?.idusuario;

      localStorage.setItem('loggedIn', 'true');
      localStorage.setItem('username', response.nome);
      localStorage.setItem('token', response.jwt);
      localStorage.setItem('adminToken', response.adminToken);
      localStorage.setItem('userToken', response.userToken);
      localStorage.setItem('usuariologado', response.nome);
      localStorage.setItem('idfilialusuario', response.filial);
      localStorage.setItem('nomefilialusuario', response.nomefilial);
      localStorage.setItem('idvendedorusuario', idVendedorUsuario);
      localStorage.setItem('iddepartamentousuario', idDepartamentoUsuario);
      localStorage.setItem('idusuario', idUsuario);
      localStorage.setItem('last_jwt_cookie', jwtCookie);
      
      return true;
    }
    
    return false;
  } catch (error) {
    if (isUserAuthenticated(false)) {
      return true;
    }
    return false;
  }
};
